import { uniqBy } from 'lodash-es';
import { isArray } from '@mts-fe/utils';
import { IN_DEV } from '@mts/utils/env';
import API, { parseConfigValue } from '@/api/ims-system';
import { getGlobalStore } from '@/store';
import type { FormSchema } from '..';

export const createFormCache = (configKey?: string) => {
  if (!configKey || IN_DEV) return;

  const globalStore = getGlobalStore();
  return {
    restore(updateSchema: (data: Partial<FormSchema> | Partial<FormSchema>[]) => Promise<void>) {
      API.getSysConfig({ configKey })
        .then(parseConfigValue)
        .then((res) => {
          if (!isArray(res)) return;

          updateSchema(res as FormSchema[]);
          globalStore.userConfg[configKey] = res;
        });
    },
    savePin(schema: Partial<FormSchema>) {
      const cache = globalStore.getConfig[configKey] || [];
      const configValue = JSON.stringify(uniqBy([schema, ...cache], 'field'));
      globalStore.updateConfig({ usageScene: 'search_cache', configKey, configValue });
    },
    async clear() {
      return API.deleteSysConfig({ configKey }).then(() => location.reload());
    },
  };
};
